import LocalizedStrings from 'react-localization'

export const strings = new LocalizedStrings({
  en: {
    defaultTagLabel: 'Undefined',
  },
})
